// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar-container-UsArK {
  flex: 1;
  height: 32px;
  width: 260px;
  display: flex;
  gap: 6px;
  align-items: center;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-neutral-300);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  padding: 0px 8px;
}

.search-bar-container-UsArK:focus-within {
  border-color: var(--color-neutral-800);
  box-shadow: 0 0 0 0.5px var(--color-neutral-800);
}

.search-bar-searchIcon-EZVyI {
  flex-shrink: 0;
  --size: 20px;
  color: var(--color-neutral-500);
  cursor: default;
}

.search-bar-input-Y8TBZ {
  display: block;
  flex: 1;
  min-width: 0px;
  font-size: 14px;
  border: none;
  outline: none;
}

.search-bar-clearIcon-dGnL3 {
  width: auto;
  height: auto;
  flex-shrink: 0;
  font-size: 20px;
  color: var(--color-neutral-700);
}
`, "",{"version":3,"sources":["webpack://./src/components/search-bar/search-bar.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,+BAA+B;EAC/B,0CAA0C;EAC1C,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,OAAO;EACP,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".container {\n  flex: 1;\n  height: 32px;\n  width: 260px;\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-neutral-300);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  padding: 0px 8px;\n}\n\n.container:focus-within {\n  border-color: var(--color-neutral-800);\n  box-shadow: 0 0 0 0.5px var(--color-neutral-800);\n}\n\n.searchIcon {\n  flex-shrink: 0;\n  --size: 20px;\n  color: var(--color-neutral-500);\n  cursor: default;\n}\n\n.input {\n  display: block;\n  flex: 1;\n  min-width: 0px;\n  font-size: 14px;\n  border: none;\n  outline: none;\n}\n\n.clearIcon {\n  width: auto;\n  height: auto;\n  flex-shrink: 0;\n  font-size: 20px;\n  color: var(--color-neutral-700);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `search-bar-container-UsArK`,
	"searchIcon": `search-bar-searchIcon-EZVyI`,
	"input": `search-bar-input-Y8TBZ`,
	"clearIcon": `search-bar-clearIcon-dGnL3`
};
export default ___CSS_LOADER_EXPORT___;
